"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Constants = void 0;
var Constants = /** @class */ (function () {
    function Constants() {
    }
  
    Constants.apiURL = 'https://clientportal.boland.com';
    Constants.secURL = 'https://clientportal.boland.com/BolandSec';
    return Constants;
}());
exports.Constants = Constants;
